import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { LinkButton, useLang } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
import { MetricLayout } from '../entities/metric-layout';
import { IndicatorLayoutComponentProps } from '../../types';
import { EntityQuarterlyGrowthChart } from '../entities/entity-quarterly-growth-chart';
import { DottedChevronRightHeavyIconGlyph } from '@shapeable/icons';
import { MapLinkButton } from '../elements/map-link-button';
const cls = classNames('indicator-layout-trail-bar-chart');

export type IndicatorLayoutGrowthChartProps = IndicatorLayoutComponentProps & {
};

export const IndicatorLayoutGrowthChartDefaultProps: Omit<IndicatorLayoutGrowthChartProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(6)};
  `,
});

const ButtonStyles = breakpoints({
  base: css`
    width: 100%;
    padding-top: ${theme.UNIT(4)};
  `,
});

const ChartStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Button: styled(LinkButton)`${ButtonStyles}`,
    MapButton: styled(MapLinkButton)`${ButtonStyles}`,
    Chart: styled(EntityQuarterlyGrowthChart)`${ChartStyles}`,
};

export const IndicatorLayoutGrowthChart: Shapeable.FC<IndicatorLayoutGrowthChartProps> = (props) => {
  const { className, children, entity } = props;
  const t = useLang();

  const { result, subtitle } = entity || {};
  const { keyValuePairs = [], indicator } = result || {};
  const { links } = indicator || {};

  const link = !!links?.length && links[0]?.url || links[0]?.path || '#';
  const linkLabel = (!!links?.length && links[0]?.label) || links[0]?.name;

  if (!keyValuePairs.length) {
    return null;
  }

  return (
      <My.Container 
        showContent 
        entity={entity} 
        className={className}
        hasPadding={false}
        ratio={1}
        stretch={true}
      >
        <My.Chart
          valueLabel={`# ${subtitle}`}
          items={keyValuePairs} 
        />
        {
          !!link && link === '#map' ? (
            <My.MapButton variant='slim' entityTypeNames={['Organisation']} href={link} icon={DottedChevronRightHeavyIconGlyph}>{t(linkLabel)}</My.MapButton>
           ) : (
            <My.Button variant='slim' href={link} icon={DottedChevronRightHeavyIconGlyph}>{t(linkLabel)}</My.Button>
          )
        }
      </My.Container>
    )
};

IndicatorLayoutGrowthChart.defaultProps = IndicatorLayoutGrowthChartDefaultProps;
IndicatorLayoutGrowthChart.cls = cls;